!function(t) {
    var e = {};

    function r(n) {
        if (e[n]) return e[n].exports;
        var o = e[n] = { i: n, l: !1, exports: {} };
        return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports
    }
    r.m = t, r.c = e,
    r.d = function(t, e, n) { r.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: n }) },
    r.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" });
        Object.defineProperty(t, "__esModule", { value: !0 })
    },
    r.t = function(t, e) {
        if (1 & e && (t = r(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var n = Object.create(null);
        if (r.r(n), Object.defineProperty(n, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t)
            for (var o in t) r.d(n, o, function(e) { return t[e] }.bind(null, o));
        return n
    },
    r.n = function(t) {
        var e = t && t.__esModule ? function() { return t.default } : function() { return t };
        return r.d(e, "a", e), e
    },
    r.o = function(t, e) { return Object.prototype.hasOwnProperty.call(t, e) },
    r.p = "",
    r(r.s = 0)
}([function(t, e, r) {
    t.exports = r(1)

}, function(t, e, r) {
    "use strict";

    // ─── Utility: poll until condition() is true, then resolve ───
    function n(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1e4;
        return new Promise(function(r) {
            var n = setInterval(function() {
                t() && (r(t()), clearInterval(n), n = null)
            }, 50);
            setTimeout(function() {
                null !== n && (clearInterval(n), console.log("PT396: condition false"))
            }, e)
        })
    }

    // ─── FIX 1: getLiveProductEl(directEl)
    // Accepts a direct element reference so there is ZERO timing dependency on
    // the handle class. Falls back to the handle-class lookup only when no
    // direct reference is provided (e.g. inside the ATC handler). ───
    function getLiveProductEl(directEl) {
        if (directEl && directEl.isConnected) return directEl;
        var popupWrapper = document.querySelector('.pt396_popupWrapper');
        if (!popupWrapper) return null;
        var handleClass = Array.from(popupWrapper.classList).find(function(cls) {
            return cls.startsWith('pt396-handle-');
        });
        if (!handleClass) return null;
        var handle = handleClass.replace('pt396-handle-', '');
        return document.querySelector('.ProductItem.' + handle);
    }

    // ─── FIX 2: refreshPopupPrices
    // Re-reads prices from the live PT242 widget on the clicked ProductItem and
    // writes them into the popup at open time.  Polls until the widget is ready.
    // This fixes the broken layout and wrong ATC price after a filter re-render. ───
    function refreshPopupPrices(productEl, popupEl, attempt) {
        attempt = attempt || 0;
        if (attempt > 50) return; // give up after ~5 s

        var onetimeWidget   = productEl.querySelector('.PT242__OptionWidget--Onetime span.PT242__OptionWidget--Price');
        var subWidget       = productEl.querySelector('.PT242__OptionWidget--Subscription span.PT242__OptionWidget--Price');
        var subLabelWidget  = productEl.querySelector('.PT242__OptionWidget--Subscription span.PT242__OptionWidget--Label');

        var onetimePrice = onetimeWidget  ? onetimeWidget.textContent.trim()  : '';
        var subPrice     = subWidget      ? subWidget.textContent.trim()      : '';
        var subLabel     = subLabelWidget ? subLabelWidget.textContent.trim() : '';

        if (!onetimePrice) {
            // PT242 widget not ready yet — try again in 100 ms
            return setTimeout(function() { refreshPopupPrices(productEl, popupEl, attempt + 1); }, 100);
        }

        // Always write the one-time price into every slot that needs it
        var oneTimeSpan   = popupEl.querySelector('span.pt396_one_time_real_price');
        var oneTimeBox    = popupEl.querySelector('.pt_416_onetime_left_price');
        var normalPriceEl = popupEl.querySelector('.pt_413_subscription_left_normal_price');
        var cutPriceEl    = popupEl.querySelector('span.pt396_subscription_radio_cut_price');
        if (oneTimeSpan)   oneTimeSpan.textContent   = onetimePrice;
        if (oneTimeBox)    oneTimeBox.textContent    = onetimePrice;
        if (normalPriceEl) normalPriceEl.textContent = onetimePrice;
        if (cutPriceEl)    cutPriceEl.textContent    = onetimePrice;

        if (subPrice) {
            // Subscription product — populate subscription price & heading
            var subPriceSpan  = popupEl.querySelector('span.pt396_subscription_radio_real_price');
            var greenPriceEl  = popupEl.querySelector('.pt_413_subscription_left_green_price');
            var atcPriceEl    = popupEl.querySelector('span.pt396_addToCart_button_price');
            if (subPriceSpan) subPriceSpan.textContent = subPrice;
            if (greenPriceEl) greenPriceEl.textContent = subPrice;
            if (atcPriceEl)   atcPriceEl.textContent   = subPrice;
            if (subLabel) {
                var subHeadingEl = popupEl.querySelector('span.pt396_subscription_radio_heading');
                if (subHeadingEl) subHeadingEl.textContent = subLabel;
            }
        } else {
            // One-time only product — ATC button shows the one-time price
            var atcPriceElOt = popupEl.querySelector('span.pt396_addToCart_button_price');
            if (atcPriceElOt) atcPriceElOt.textContent = onetimePrice;
        }
    }

    // ─── FIX 3: setupPT416ToggleSwitches(popupContainer, clickedProductEl)
    // Now accepts clickedProductEl directly — no reliance on handle-class timing. ───
    function setupPT416ToggleSwitches(popupContainer, clickedProductEl) {
        if (!popupContainer) return;

        var oneTimeToggle        = popupContainer.querySelector('.pt_416_toggle_input_one_time');
        var subscriptionToggle   = popupContainer.querySelector('.pt_416_toggle_input_subscription');
        var oneTimeWrapper       = popupContainer.querySelector('.pt_416_onetime_wrapper');
        var subscriptionWrapper  = popupContainer.querySelector('.pt_416_subscription_wrapper');
        var oneTimeRadioWrapper  = popupContainer.querySelector('.pt396_one_time_radio_wrapper');
        var subscriptionRadioWrapper = popupContainer.querySelector('.pt396_subscription_radio_wrapper');
        var priceDisplayOne      = popupContainer.querySelector('.pt_413_subscription_left_normal_price');
        var priceDisplaySubs     = popupContainer.querySelector('.pt_413_subscription_left_green_price');
        var priceDisplayOneBox   = popupContainer.querySelector('.pt_416_onetime_left_price');
        var subHeading           = popupContainer.querySelector('.pt396_subscription_radio_heading');
        var subHeadingDest       = popupContainer.querySelector('.pt_416_subscription_left_heading');

        // Populate prices from the live PT242 widget on the correct product
        function populatePrices() {
            var liveProduct = getLiveProductEl(clickedProductEl);
            if (!liveProduct) return false;

            var onetimeEl = liveProduct.querySelector('.PT242__OptionWidget--Onetime span.PT242__OptionWidget--Price');
            var subEl     = liveProduct.querySelector('.PT242__OptionWidget--Subscription span.PT242__OptionWidget--Price');

            if (!onetimeEl || !onetimeEl.textContent.trim()) return false; // not ready yet

            if (priceDisplayOne)    priceDisplayOne.textContent    = onetimeEl.textContent.trim();
            if (priceDisplayOneBox) priceDisplayOneBox.textContent = onetimeEl.textContent.trim();
            if (subEl && priceDisplaySubs) priceDisplaySubs.textContent = subEl.textContent.trim();
            if (subHeading && subHeadingDest) subHeadingDest.textContent = subHeading.textContent;

            return true;
        }

        if (!populatePrices()) {
            var poll = setInterval(function() {
                if (populatePrices()) clearInterval(poll);
            }, 100);
            setTimeout(function() { clearInterval(poll); }, 5000);
        }

        if (oneTimeToggle) {
            oneTimeToggle.addEventListener('click', function() {
                if (oneTimeWrapper && subscriptionWrapper) {
                    oneTimeWrapper.classList.add('pt_416_hidden');
                    subscriptionWrapper.classList.remove('pt_416_hidden');
                }
                if (subscriptionRadioWrapper) subscriptionRadioWrapper.click();
            });
        }

        if (subscriptionToggle) {
            subscriptionToggle.addEventListener('click', function() {
                if (oneTimeWrapper && subscriptionWrapper) {
                    subscriptionWrapper.classList.add('pt_416_hidden');
                    oneTimeWrapper.classList.remove('pt_416_hidden');
                }
                if (oneTimeRadioWrapper) oneTimeRadioWrapper.click();
            });
        }
    }

    r.r(e);

    var o = {
        subCollections:             "body.template-collection",
        productItem:                ".CollectionMain .ProductList .ProductItem",
        productWrapperRating:       ".Product__Wrapper .ProductItem__Rating",
        productItemAddToCartBtn:    ".ProductItem .ProductItem_AddToCartBtn .Button--secondary",
        productGalleryCarouselImage:".Product__Gallery .Product__Slideshow.Carousel .AspectRatio--withFallback > img"
    };

    var i = {
        productPopupWrapper: "\n        <div class='pt396_popupWrapper'>\n        <div class='pt396_popupOverlay'></div>\n        <div class='pt396_popupContainer'>\n        <div class='pt396_closePopup'>\n        <div class='pt396_closePopup_btn'><img src='https://cdn.shopify.com/s/files/1/2135/4367/files/image_2_1_92c1ab40-9b91-4d91-86ec-abada9b0b233.png?v=1739164204'/></div>\n        </div>\n        </div></div>",
        productPopup: '<div class=\'pt396_popup\'><div class=\'pt396_imageContainer\'></div><div class=\'pt396_productDetailContainer\'><p class=\'pt396_productName\'></p><div class=\'pt396_reviewSection\'></div><div class=\'pt396_productBenefitsContainer\'></div><div class=\'pt396_subscription_wrapper pt_396_hide pt_396_subscriptionOption_not_available\'><div class="pt396_one_time_radio_wrapper pt396_radio_block"><span class="pt396_one_time_heading pt396_radio_heading">One-time purchase</span><span class="pt396_one_time_real_price">$68</span><p class="pt396_one_time_guarantee_text">No Subscription</p></div><div class="pt396_subscription_radio_wrapper pt396_radio_block pt_396_active_block"><span class="pt396_subscription_radio_heading_wrapper"><span class="pt396_subscription_radio_heading pt396_radio_heading">Subscribe and Save 10%</span><span class="pt396_subscription_radio_real_price"></span><span class="pt396_subscription_radio_cut_price"></span></span><p class="pt396_subscription_guarantee_text">Pause & cancel anytime</p><p class="pt396_subscription_time_text">Delivery every 30 Days</p></div></div><div class="pt_416_onetime_wrapper pt_416_hidden"><div class="pt_416_onetime_left_container"><div class="pt_416_onetime_top_section"><div class="pt_416_onetime_left_top_wrapper"><p class="pt_416_onetime_left_heading">One-time purchase</p></div><div class="pt_416_toggle_switch pt_416_toggle_input_one_time"><label for="toggleSwitchSub" class="pt_416_toggle_label"></label></div></div><div class="pt_416_lower_data_wrapper"><div class="pt_416_lower_left_wrapper"><p class="pt_416_onetime_left_saving_copy">Want to save 10%?</p><p class="pt_416_onetime_left_lower_cta">Switch to Subscription!</p></div><div class="pt_416_lower_right_wrapper"><p class="pt_416_onetime_left_price">$68</p><p class="pt_432_cost_per_serving"></p></div></div></div></div><div class="pt_416_subscription_wrapper"><div class="pt_416_subscription_left_container"><div class="pt_416_subscription_top_section"><div class="pt_416_subscription_left_top_wrapper"><p class="pt_416_subscription_left_heading">Subscribe &amp; save 10%</p></div><div class="pt_416_toggle_switch pt_416_toggle_input_subscription"><label for="toggleSwitchSub" class="pt_416_toggle_label"></label></div></div><div class="pt_416_subscription_lower_text_wrapper"><div class="pt_416_left_lower_section"><p class="pt_416_subscription_lower_text">Lock in your discount <span class="pt_416_inner_span_points">for life</span></p><p class="pt_416_subscription_lower_text">Delivery every 30 days</p><p class="pt_416_subscription_lower_text">Try It Risk-Free For 90 Days</p></div><div class="pt_416_left_lower_section"><p class="pt_413_subscription_left_price"><span class="pt_413_subscription_left_green_price"></span> <span class="pt_413_subscription_left_normal_price Price Price--compareAt"></span><span class="pt_432_cost_per_serving_sub hidden-tablet-and-up"></span></p></div></div></div></div><button class=\'pt396_addToCart_button\'>ADD TO CART<span class="pt396_addToCart_button_separator"></span><span class="pt396_addToCart_button_price">$68</span></button><div class=\'pt396_productAccordian\'><button class="pt396_ingredient_accordian_button" aria-expanded="false">Ingredients<span class="pt396_ingredient_accordian_plus_icon"></span></button><div class="pt396_ingredient_accordian_dropdown_content"></div></div><a class=\'pt396_productDescription\'>View Full Product</a></div></div>',
        loader: '<div id="pt_396_loader_popin" class="pt_396_loader pt_396_hidden"><div class="spinner"></div></div>'
    };

    r(2); r(6);

    function c() {
        $(".pt396_popupWrapper .pt396_popupContainer .pt396_imageContainer > div").flickity({
            cellAlign: "left", contain: !0, autoPlay: !1,
            wrapAround: !0, prevNextButtons: !0, pageDots: !0
        })
    }

    var p = function() {
        !function(t, e) {
            if (document.querySelector('script[src="'.concat(t, '"]'))) { e && e(); }
            else {
                var r = document.createElement("script");
                r.src = t; r.onload = e; document.body.appendChild(r);
            }
        }("https://cdnjs.cloudflare.com/ajax/libs/flickity/2.2.2/flickity.pkgd.min.js", c)
    };

    function a() {
        var popup = document.querySelector(".pt396_popupContainer .pt396_popup");
        if (popup) popup.remove();
        document.body.classList.remove("pt396_popupActive");
    }

    // ─── FIX 4: ATC handler u()
    // Scoped to the currently open ProductItem via getLiveProductEl() instead of
    // document.querySelector() which always picks the FIRST match in the DOM.
    // This fixes ATC not working after a filter re-render changes product order. ───
    function u(t) {
        var varId = t.target.getAttribute("data-var_id");

        // Prefer the directly tracked product; fall back to handle-class lookup
        var targetProductEl = getLiveProductEl();
        var r = targetProductEl
            ? targetProductEl.querySelector(".ProductItem_AddToCartBtn button[data-var_id='" + varId + "']")
            : document.querySelector(".CollectionMain .ProductItem .ProductItem_AddToCartBtn button[data-var_id='" + varId + "']");

        if (!r) { console.warn('PT396: ATC button not found for var_id', varId); return; }

        if (t.target.closest(".pt396_popup").querySelector(".pt_396_subscriptionOption_not_available")) {
            r.click(); a();
        } else {
            var o = t.target.closest(".pt396_popup")
                          .querySelector(".pt396_subscription_wrapper")
                          .querySelector(".pt_396_active_block");
            o && n(function() {
                return r.closest(".ProductItem").querySelectorAll(".PT242__OptionWidget--Options").length > 0
            }, 5e4).then(function() {
                var widgetOptions = r.closest(".ProductItem").querySelector(".PT242__OptionWidget--Options");
                if (o.classList.contains("pt396_subscription_radio_wrapper")) {
                    var subBtn = widgetOptions.querySelector(".PT242__OptionWidget--Subscription");
                    subBtn && subBtn.click();
                } else if (o.classList.contains("pt396_one_time_radio_wrapper")) {
                    var otBtn = widgetOptions.querySelector(".PT242__OptionWidget--Onetime");
                    otBtn && otBtn.click();
                }
                setTimeout(function() {
                    var subMatch = null !== document.querySelector(".pt396_popupContainer .pt396_subscription_radio_wrapper.pt_396_active_block")
                                && null !== document.querySelector(".PT242__OptionWidget--Subscription.PT242__OptionWidget--Active");
                    var otMatch  = null !== document.querySelector(".pt396_popupContainer .pt396_one_time_radio_wrapper.pt_396_active_block")
                                && null !== document.querySelector(".PT242__OptionWidget--Onetime.PT242__OptionWidget--Active");
                    if (subMatch || otMatch) {
                        r.closest(".ProductItem").querySelector("button.PT242__OptionWidget--Button").click();
                        a();
                    }
                }, 50)
            })
        }
    }

    // Updates the ATC price span when user picks one-time vs subscription in popup
    function d(t, e, r, nn) {
        e.classList.remove("pt_396_active_block");
        r.classList.remove("pt_396_active_block");
        t.currentTarget.classList.add("pt_396_active_block");
        if (t.currentTarget === r) {
            var subRealPrice = r.querySelector(".pt396_subscription_radio_real_price");
            if (subRealPrice) nn.textContent = subRealPrice.textContent;
        } else if (t.currentTarget === e) {
            var otRealPrice = e.querySelector(".pt396_one_time_real_price");
            if (otRealPrice) nn.textContent = otRealPrice.textContent;
        }
    }

    // Called by optiReady for every .ProductItem — fetches product page and
    // injects a hidden .pt396_popup into the card for later cloning into the modal.
    function _(productItemEl) {
        n(function() {
            return null !== productItemEl
                .querySelector(".ProductItem .ProductItem_AddToCartBtn .Button--secondary")
                .getAttribute("data-var_id")
        }, 5e4).then(function() {

            var productLink = productItemEl.querySelector(".ProductItem__Wrapper > a").href;
            var productName = productItemEl.querySelector("h2.ProductItem__Title.Heading").textContent.trim();
            var productId   = productItemEl.querySelector(".ProductItem .ProductItem_AddToCartBtn .Button--secondary").getAttribute("data-var_id");

            productItemEl.classList.add("pt_396_disable_link");

            // Callback that runs once the product page HTML has been fetched
            function buildPopupFromFetchedPage(fetchedSection) {
                var reviewHTML      = fetchedSection.querySelector(o.productWrapperRating).outerHTML;
                var benefitsHTML    = fetchedSection.querySelector(".ProductMeta__Tags").outerHTML;
                var ingredientEl    = fetchedSection.querySelector(".Collapsible.IngrediantTab .Collapsible__Inner .Collapsible__Content .HowToDrink_Tab");
                var ingredientHTML  = ingredientEl ? ingredientEl.innerHTML : "";

                // Build image wrapper from fetched gallery images
                var galleryImgs = fetchedSection.querySelectorAll(o.productGalleryCarouselImage);
                var imageWrapper = document.createElement("div");
                galleryImgs.forEach(function(img) { imageWrapper.insertAdjacentElement("beforeend", img.cloneNode()); });

                // Hard-coded gift card image override
                if ("48598486214" === productId) {
                    var imgs = imageWrapper.querySelectorAll("img");
                    if (imgs.length > 0) { imgs[0].src = "https://www.piquelife.com/cdn/shop/products/eGiftCard_A_1copy_400x.jpg?v=1644891854"; imgs[0].alt = "Hardcoded Product Image 1"; }
                    if (imgs.length > 1) { imgs[1].src = "https://www.piquelife.com/cdn/shop/products/eGiftCard_FAFAFA_1200x.jpg?v=1644893316"; imgs[1].alt = "Hardcoded Product Image 2"; }
                }

                // Inject the popup skeleton into the ProductItem
                var popupWrapper = document.createElement("div");
                popupWrapper.classList.add("pt396_product_popupWrapper");
                popupWrapper.innerHTML = i.productPopup;
                productItemEl.insertAdjacentElement("beforeend", popupWrapper);

                var s = popupWrapper; // alias used below
                s.querySelector(".pt396_productName").innerHTML            = productName;
                s.querySelector(".pt396_reviewSection").innerHTML           = reviewHTML;
                s.querySelector(".pt396_productBenefitsContainer").innerHTML = benefitsHTML;
                s.querySelector("a.pt396_productDescription").setAttribute("href", productLink);
                s.querySelector(".pt396_ingredient_accordian_dropdown_content").innerHTML = ingredientHTML;
                s.querySelector(".pt396_imageContainer").insertAdjacentElement("afterbegin", imageWrapper);
                s.querySelector(".pt396_addToCart_button").setAttribute("data-var_id", productId);

                // Wait for PT242 widget to appear, then bake prices into the hidden popup node
                n(function() { return null != productItemEl.querySelector(".PT242__OptionWidget"); }, 5e4)
                .then(function() {
                    // Add handle class to global popupWrapper (used for CSS targeting)
                    var globalPopupWrap = document.querySelector(".pt396_popupWrapper");
                    var handle = (productLink || "").split("/").filter(Boolean).pop();
                    if (handle && globalPopupWrap) globalPopupWrap.classList.add(handle);

                    var onetimePrice = productItemEl.querySelector(".PT242__OptionWidget--Onetime span.PT242__OptionWidget--Price").textContent.trim();
                    var subLabelEl   = productItemEl.querySelector(".PT242__OptionWidget--Subscription span.PT242__OptionWidget--Label");
                    var subPriceEl2  = productItemEl.querySelector(".PT242__OptionWidget--Subscription span.PT242__OptionWidget--Price");
                    var subLabel     = subLabelEl  ? subLabelEl.textContent.trim()  : "";
                    var subPrice2    = subPriceEl2 ? subPriceEl2.textContent.trim() : "";

                    var costPerServing    = (productItemEl.querySelector(".pt_413_onetime_wrapper span.pt_432_cost_per_serving") || {}).textContent || "";
                    var costPerServingSub = (productItemEl.querySelector(".PT242__OptionWidget--Subscription--Info span.pt_432_cost_per_serving_sub") || {}).textContent || "";

                    if (subLabelEl) s.classList.add("not-subscription");

                    s.querySelector("span.pt396_one_time_real_price").textContent   = onetimePrice;
                    s.querySelector("span.pt396_subscription_radio_heading").textContent = subLabel;
                    s.querySelector(".pt_432_cost_per_serving").textContent         = costPerServing.trim();
                    s.querySelector(".pt_432_cost_per_serving_sub").textContent     = costPerServingSub.trim();
                    s.querySelector("span.pt396_subscription_radio_real_price").textContent = subPrice2;
                    s.querySelector("span.pt396_subscription_radio_cut_price").textContent  = onetimePrice;
                    s.querySelector("span.pt396_addToCart_button_price").textContent        = subPrice2 || onetimePrice;
                    s.querySelector(".pt396_subscription_wrapper").classList.remove("pt_396_hide", "pt_396_subscriptionOption_not_available");

                    // If popup is already open for this product, update its live content too
                    if (document.body.classList.contains("pt396_popupActive")) {
                        var openPopupName = document.querySelector(".pt396_popupActive .pt396_popupContainer .pt396_productName");
                        if (openPopupName && productItemEl.querySelector(".ProductItem__Title").textContent.trim().toLowerCase() === openPopupName.textContent.trim().toLowerCase()) {
                            var newSubWrapper = productItemEl.querySelector(".pt396_subscription_wrapper").cloneNode(!0);
                            var newAtcBtn     = productItemEl.querySelector("button.pt396_addToCart_button").cloneNode(!0);
                            var openContainer = document.querySelector(".pt396_popupActive .pt396_popupContainer");
                            var oldSubWrapper = openContainer.querySelector(".pt396_subscription_wrapper");
                            var oldAtcBtn     = openContainer.querySelector("button.pt396_addToCart_button");
                            if (openContainer && newSubWrapper && oldSubWrapper && oldAtcBtn) {
                                oldSubWrapper.remove(); oldAtcBtn.remove();
                                var benefitsContainer = openContainer.querySelector(".pt396_productBenefitsContainer");
                                benefitsContainer.insertAdjacentElement("afterend", newAtcBtn);
                                benefitsContainer.insertAdjacentElement("afterend", newSubWrapper);
                                var liveSubWrapper = openContainer.querySelector(".pt396_subscription_wrapper");
                                var liveOtRow      = liveSubWrapper.querySelector(".pt396_one_time_radio_wrapper");
                                var liveSubRow     = liveSubWrapper.querySelector(".pt396_subscription_radio_wrapper");
                                var liveAtcPrice   = openContainer.querySelector("button.pt396_addToCart_button .pt396_addToCart_button_price");
                                liveOtRow.addEventListener("click",  function(t) { return d(t, liveOtRow, liveSubRow, liveAtcPrice); });
                                liveSubRow.addEventListener("click", function(t) { return d(t, liveOtRow, liveSubRow, liveAtcPrice); });
                                openContainer.querySelector(".pt396_addToCart_button").addEventListener("click", u);
                            }
                        }
                    }
                });

                productItemEl.classList.remove("pt_396_disable_link");

                // Bind click handlers on every anchor inside this ProductItem
                productItemEl.querySelectorAll("a[href]").forEach(function(anchor) {
                    anchor.addEventListener("click", function(evt) {
                        evt.preventDefault();

                        // ─── FIX: Resolve clickedProductEl fresh at click time ───
                        var clickedLink      = evt.target.closest("a[href]");
                        var clickedProductEl = clickedLink ? clickedLink.closest(".ProductItem") : null;
                        if (!clickedProductEl) return;

                        var clonedPopup = clickedProductEl.querySelector(".pt396_popup")
                            ? clickedProductEl.querySelector(".pt396_popup").cloneNode(true)
                            : null;

                        // Open the modal with the cloned popup
                        (function openModal(clonedNode) {
                            var modalContainer = document.querySelector(".pt396_popupContainer");
                            if (clonedNode && modalContainer) {
                                modalContainer.insertAdjacentElement("beforeend", clonedNode);
                                if (modalContainer.querySelector(".pt396_imageContainer > div")) setTimeout(p, 100);
                                modalContainer.querySelector(".pt396_addToCart_button").addEventListener("click", u);

                                // Ingredient accordion
                                var accordionBtn     = modalContainer.querySelector(".pt396_ingredient_accordian_button");
                                var accordionContent = modalContainer.querySelector(".pt396_ingredient_accordian_dropdown_content");
                                accordionBtn.addEventListener("click", function() {
                                    var expanded = "true" === accordionBtn.getAttribute("aria-expanded");
                                    accordionBtn.setAttribute("aria-expanded", !expanded);
                                    accordionContent.classList.toggle("pt_396_drop_active");
                                });

                                // One-time / Subscription radio rows
                                var subWrapper  = modalContainer.querySelector(".pt396_subscription_wrapper");
                                var otRow       = subWrapper.querySelector(".pt396_one_time_radio_wrapper");
                                var subRow      = subWrapper.querySelector(".pt396_subscription_radio_wrapper");
                                var atcPriceSpan = modalContainer.querySelector("button.pt396_addToCart_button .pt396_addToCart_button_price");

                                otRow.addEventListener("click", function(t) {
                                    // ─── FIX: Use clickedProductEl directly — guaranteed correct product ───
                                    var liveEl = getLiveProductEl(clickedProductEl);
                                    if (liveEl) {
                                        var otWidget  = liveEl.querySelector(".PT242__OptionWidget .PT242__OptionWidget--Onetime");
                                        var subWidget2 = liveEl.querySelector(".PT242__OptionWidget .PT242__OptionWidget--Subscription");
                                        if (otWidget)  otWidget.classList.add("PT242__OptionWidget--Active");
                                        if (subWidget2) subWidget2.classList.remove("PT242__OptionWidget--Active");
                                    }
                                    return d(t, otRow, subRow, atcPriceSpan);
                                });

                                subRow.addEventListener("click", function(t) {
                                    var liveEl = getLiveProductEl(clickedProductEl);
                                    if (liveEl) {
                                        var otWidget  = liveEl.querySelector(".PT242__OptionWidget .PT242__OptionWidget--Onetime");
                                        var subWidget2 = liveEl.querySelector(".PT242__OptionWidget .PT242__OptionWidget--Subscription");
                                        if (otWidget)  otWidget.classList.remove("PT242__OptionWidget--Active");
                                        if (subWidget2) subWidget2.classList.add("PT242__OptionWidget--Active");
                                    }
                                    return d(t, otRow, subRow, atcPriceSpan);
                                });

                                // Hide accordion section if empty
                                var accordionSection = modalContainer.querySelector(".pt396_productAccordian");
                                if (!accordionContent || accordionContent.innerHTML.trim() === "") {
                                    accordionSection.classList.add("pt_396_no_content_ingredient_hidden");
                                }
                            }

                            document.body.classList.contains("pt396_popupActive") || document.body.classList.add("pt396_popupActive");

                            var popupWrapperEl = document.querySelector(".pt396_popupWrapper");

                            // ─── FIX: Set handle class FIRST (before any price/toggle setup) ───
                            var productHandleClass = Array.from(clickedProductEl.classList).find(function(cls) { return cls !== "ProductItem"; });
                            if (popupWrapperEl && productHandleClass) {
                                popupWrapperEl.className = popupWrapperEl.className
                                    .split(" ")
                                    .filter(function(cls) { return !cls.startsWith("pt396-handle-"); })
                                    .join(" ");
                                popupWrapperEl.classList.add("pt396-handle-" + productHandleClass);
                            }

                            // ─── FIX: Re-read prices from live PT242 widget at open time.
                            // This overwrites stale baked-in prices and fixes layout/ATC after filtering. ───
                            if (clonedNode) refreshPopupPrices(clickedProductEl, clonedNode);

                            // ─── FIX: Pass clickedProductEl directly — no handle-class timing race ───
                            setupPT416ToggleSwitches(document.querySelector(".pt396_popupContainer"), clickedProductEl);

                        }(clonedPopup));
                    });
                });
            } // end buildPopupFromFetchedPage

            fetch(productLink)
                .then(function(res) { return res.text(); })
                .then(function(html) {
                    var doc = (new DOMParser).parseFromString(html, "text/html");
                    try {
                        var section = doc.querySelector("section.Product");
                        buildPopupFromFetchedPage(section);
                    } catch(err) {
                        buildPopupFromFetchedPage(null, err);
                    }
                })
                .catch(function(err) { console.warn("PT396: fetch failed", err); });

        }); // end n().then
    } // end _()

    // ─── Bootstrap ───
    !function() {
        !function(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "v1";
            window.optiActiveTests = window.optiActiveTests || {};
            window.optiActiveTests[t] = e;
        }("PT_396", "v1");

        n(function() {
            return null != document.querySelector(o.subCollections)
                && window.location.href.includes("collections/")
                && "function" == typeof window.jQuery
        }).then(function() {
            if (window.innerWidth > 767) return; // desktop — skip

            // Inject optiReady if not already present
            if ("function" != typeof window.optiReady) {
                var _t, _e = [], _doc = window.document,
                    _MO = window.MutationObserver || window.WebKitMutationObserver;
                function _scan() {
                    for (var entry, nodes, i2 = 0, len = _e.length; i2 < len; i2++) {
                        entry = _e[i2];
                        nodes = _doc.querySelectorAll(entry.selector);
                        for (var node, j = 0; j < nodes.length; j++) {
                            node = nodes[j];
                            node.ready || (node.ready = []);
                            node.ready[i2] || (node.ready[i2] = !0, entry.fn.call(node, node));
                        }
                    }
                }
                window.optiReady = function(sel, fn) {
                    _e.push({ selector: sel, fn: fn });
                    _t || (_t = new _MO(_scan)).observe(_doc.documentElement, { childList: !0, subtree: !0 });
                    _scan();
                };
            }

            document.body.classList.add("pt_396");

            if (!document.querySelector(".pt396_popupWrapper")) {
                document.body.insertAdjacentHTML("beforeend", i.productPopupWrapper);
            }

            var overlay  = document.querySelector(".pt396_popupOverlay");
            var closeBtn = document.querySelector(".pt396_popupWrapper .pt396_closePopup_btn");
            overlay.addEventListener("click",  function() { a(); });
            closeBtn.addEventListener("click", function() { a(); });

            window.optiReady(o.productItem, function(productItemEl) {
                _(productItemEl);
            });
        });
    }();

}, function(t, e) {}, , , , function(t, e) {}]);